import { ReactNode } from "react";

interface InlineCodeTagProps {
  children: ReactNode;
}

export function InlineCodeTag({ children }: InlineCodeTagProps) {
  return (
    <code className="px-1.5 py-0.5 bg-gray-100 dark:bg-zinc-800 rounded text-sm font-mono">
      {children}
    </code>
  );
}
